import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ADMIN_EMAILS = ['admin@nordpass.no'];

const AdminRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div
        style={{
          background: '#050A12',
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <div
          style={{
            fontFamily: 'Syne, sans-serif',
            color: 'rgba(238,240,242,0.5)',
            fontSize: '0.875rem',
            letterSpacing: '0.1em',
            textTransform: 'uppercase'
          }}
        >
          Laster...
        </div>
      </div>
    );
  }

  const isAdmin =
    user &&
    (ADMIN_EMAILS?.includes(user?.email) ||
      user?.user_metadata?.role === 'admin' ||
      user?.app_metadata?.role === 'admin');

  if (!isAdmin) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default AdminRoute;
